import React, { useState } from 'react';

const ExperienceStep = ({ onComplete, initialAnswers }) => {
  const [selectedExperience, setSelectedExperience] = useState(
    initialAnswers?.experience || ''
  );

  const experiences = [
    {
      id: 'beginner',
      emoji: '🩰',
      title: 'Beginner or returning dancer',
      description: 'Less than 3 years of experience, or returning to ballet after a break'
    },
    {
      id: 'intermediate',
      emoji: '🌟',
      title: 'Intermediate dancer',
      description: 'Comfortable with pointe/men\'s jumps & stage performance experience'
    },
    {
      id: 'advanced',
      emoji: '👑',
      title: 'Advanced dancer',
      description: 'Confident in turns, balances, big jumps, and stage artistry'
    }
  ];

  const handleSelectExperience = (experienceId) => {
    setSelectedExperience(experienceId);
  };

  const handleNext = () => {
    if (selectedExperience) {
      onComplete({ experience: selectedExperience });
    }
  };

  return (
    <div className="quiz-step">
      <h2>How would you describe your ballet experience?</h2>
      <p>This helps us filter variations that match your technical level and stage readiness.</p>
      
      <div className="options-grid">
        {experiences.map((exp) => (
          <div
            key={exp.id}
            className={`option-card ${selectedExperience === exp.id ? 'selected' : ''}`}
            onClick={() => handleSelectExperience(exp.id)}
          >
            <h3>
              <span className="emoji">{exp.emoji}</span>
              {exp.title}
            </h3>
            <p>{exp.description}</p>
          </div>
        ))}
      </div>

      <div className="quiz-buttons">
        <div></div> {/* Empty div for spacing */}
        <button 
          className="btn-next" 
          onClick={handleNext}
          disabled={!selectedExperience}
        >
          Next Step →
        </button>
      </div>
    </div>
  );
};

export default ExperienceStep; 